<template>
  <div class="wrapper">
    <div id="mapContainer">
      <div class="search">
        <div class="markerTitle" v-show="storeInfoList[0]?.name">
          <img class="img" src="@/assets/gzh/marker.png" alt="" />
          <div class="title" @click="showPopup = true">
            {{ storeInfoList[0]?.name }} <van-icon name="arrow" />
          </div>
        </div>
        <van-field
          v-model="searchMap"
          :id="search_id"
          left-icon="search"
          placeholder="请输入关键字搜索附近经销商门店"
          @input="queryMapParams"
          @focus="searchFocus"
          style="margin-top: 20px"
        />
      </div>
    </div>
    <div class="location">
      <van-popup
        v-model="showPopup"
        round
        position="bottom"
        :style="{ height: '40%' }"
        closeable
        :overlay="false"
      >
        <div class="container">
          <div class="locationContainer">
            <div
              class="locationInfo"
              v-for="(item, index) in storeInfoList"
              :key="index"
            >
              <div class="shop">
                <div class="shopTitle">{{ item?.name }}</div>
                <div class="meter" v-if="item?.distance">
                  {{ item?.distance }} km
                </div>
              </div>
              <div class="info">
                <div class="content">
                  <img class="mark" src="@/assets/gzh/marker.png" alt="" />
                  <div class="infoContent">{{ item?.address }}</div>
                </div>
                <div class="linkNavigation">
                  <img class="img" src="@/assets/gzh/weizhi.png" alt="" />
                  <div class="title">
                    <a
                      :href="`https://uri.amap.com/marker?callnative=1&position=${item?.location}&name=${item?.name}&policy=0`"
                      style="color: black"
                      >导航</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
import AMapLoader from "@amap/amap-jsapi-loader";
window._AMapSecurityConfig = {
  securityJsCode: "d7dd8082c27cd068108a8e1b6aed837f"
};
export default {
  name: "mapNavigation",
  data() {
    return {
      map: null,
      searchMap: "",
      search_id: "searchId",
      auto: null,
      placeSearch: null,
      showPopup: false,
      fromAddressName: "",
      fromPosition: "",
      storeInfoList: [],
      marker: null,
      currentLocation: "",
      storeDistance: "",
      AMap: null
    };
  },
  created() {},
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      AMapLoader.reset();
      AMapLoader.load({
        key: "db734ee0deb249082595ed2fb6f74750", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          "AMap.AutoComplete",
          "AMap.PlaceSearch",
          "AMap.Geolocation",
          "AMap.Geocoder",
          "AMap.CitySearch"
        ] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then(AMap => {
          this.AMap = AMap;
          this.map = new AMap.Map("mapContainer", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 15 //初始化地图级别
            // center: [121.473667, 31.230525], //初始化地图中心点位置
            // position: [121.5273285, 31.21515044]
          });
          let geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
            maximumAge: 0, //定位结果缓存0毫秒，默认：0
            convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: true, //显示定位按钮，默认：true
            buttonPosition: "LB", //定位按钮停靠位置，默认：'LB'，左下角
            buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
            showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy: true //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          });
          this.map.addControl(geolocation);
          let autoOptions = {
            city: this.searchMap,
            input: this.search_id
          };
          this.auto = new AMap.AutoComplete(autoOptions);
          this.placeSearch = new AMap.PlaceSearch({
            map: this.map
          }); //构造地点查询类
          this.auto.on("select", this.select);

          geolocation.getCurrentPosition();
          geolocation.getCurrentPosition((status, result) => {
            if (status == "complete") {
              AMap.plugin("AMap.CitySearch", () => {
                var citySearch = new AMap.CitySearch();
                citySearch.getLocalCity((status, result1) => {
                  if (status === "complete" && result1.info === "OK") {
                    this.currentLocation =
                      result.position.lng + "," + result.position.lat;
                    const json = {
                      location: result.position.lng + "," + result.position.lat,
                      city: result1.city
                    };
                    console.log("json", json, result, result1);
                    apis.getStoreInfo(json).then(res => {
                      if (res.code === 200) {
                        this.storeInfoList = res.data.map(item => {
                          item.distance = (item.distance / 1).toFixed(2);
                          return item;
                        });
                        this.showPopup = true;
                        this.storeInfoList.forEach(item => {
                          const lnglat = item.location.split(",");
                          this.marker = new AMap.Marker({
                            map: this.map,
                            zIndex: 9999999,
                            position: [lnglat[0], lnglat[1]]
                          });
                        });
                      }
                    });
                  }
                });
              });
            } else {
              // 精准定位失败获取当前城市
              AMap.plugin("AMap.CitySearch", () => {
                var citySearch = new AMap.CitySearch();
                citySearch.getLocalCity((status, result) => {
                  if (status === "complete" && result.info === "OK") {
                    // 查询成功，result即为当前所在城市信息
                    AMap.plugin("AMap.Geocoder", () => {
                      var geocoder = new AMap.Geocoder({
                        // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                        city: result.adcode,
                        radius: 1000,
                        extensions: "all",
                        poitype: ""
                      });
                      // 根据城市获取经纬度

                      geocoder.getLocation(result.city, (status, result2) => {
                        if (status === "complete" && result2.geocodes.length) {
                          var lnglat = result2.geocodes[0].location;
                          this.currentLocation = lnglat.lng + "," + lnglat.lat;
                          const json = {
                            location: lnglat.lng + "," + lnglat.lat,
                            city: result2.geocodes[0].formattedAddress
                            // radius: 1000
                          };
                          apis.getStoreInfo(json).then(res => {
                            if (res.code === 200) {
                              this.storeInfoList = res.data.map(item => {
                                item.distance = (item.distance / 1).toFixed(2);
                                item.content =
                                  "<div style='font-size:12px;height:50px;margin-top:10px'><p style='margin-bottom:10px'>" +
                                  item.name +
                                  "</p>" +
                                  "<p>" +
                                  item.address +
                                  "</p></div>";
                                return item;
                              });
                              this.showPopup = true;
                            }
                          });
                        }
                      });
                    });
                  }
                });
              });
            }
          });
        })
        .catch(e => {
          console.log("error", e);
        });
    },
    // 搜索
    queryMapParams(value) {
      const txt = value;
      console.log("value", value);
      this.placeSearch.search(txt, (status, result) => {
        if (status == "complete" && result.info == "OK") {
          const json = {
            location:
              result.poiList.pois[0].location.lng +
              "," +
              result.poiList.pois[0].location.lat,
            district:
              result.poiList.pois[0].cityname + result.poiList.pois[0].adname
          };
          apis.getSearchAroundStoreInfo(json).then(res => {
            if (res.code === 200) {
              this.storeInfoList = res.data.map(i => {
                i.distance = (i.distance / 1).toFixed(2);
                i.content =
                  "<div style='font-size:12px;height:50px;margin-top:10px'><p style='margin-bottom:10px'>" +
                  i.name +
                  "</p>" +
                  "<p>" +
                  i.address +
                  "</p></div>";
                return i;
              });
            }
          });
        }
      });
    },
    // 搜索聚焦
    searchFocus() {
      this.showPopup = true;
    },
    // 搜索选中
    select(e) {
      console.log(e.poi);
      this.searchMap = e.poi.name;
      this.placeSearch.setCity(e.poi.adcode);
      this.placeSearch.search(e.poi.name); //关键字查询查询
      this.map.clearMap();
      // this.storeInfoList = [];
      if (e.poi.location.lng) {
        const json = {
          location: e.poi.location.lng + "," + e.poi.location.lat,
          district: e.poi.district
          // radius: 1000
        };
        apis.getSearchAroundStoreInfo(json).then(res => {
          if (res.code === 200) {
            this.storeInfoList = res.data.map(item => {
              item.distance = (item.distance / 1).toFixed(2);
              item.content =
                "<div style='font-size:12px;height:50px;margin-top:10px;'><p style='margin-bottom:10px'>" +
                item.name +
                "</p>" +
                "<p>" +
                item.address +
                "</p></div>";
              return item;
            });
          }
        });
      }
    }
  },
  watch: {
    searchMap(newValue) {
      if (newValue != "") {
        this.map.clearMap();
        this.placeSearch.search(newValue);
      }
    },
    storeInfoList(newValue) {
      this.map.clearMap();
      // const markers = [];

      newValue.forEach(item => {
        const lnglat = item?.location.split(",");
        this.marker = new this.AMap.Marker({
          map: this.map,
          position: lnglat ? [lnglat[0], lnglat[1]] : ""
        });
        this.map.add(this.marker);

        // this.marker.on("click", () => {
        //   this.marker.setLabel({
        //     position: "top-center",
        //     offset: new this.AMap.Pixel(0, -20), //设置文本标注偏移量
        //     content: item.content, //设置文本标注内容
        //     direction: "top" //设置文本标注方位
        //   });
        // });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .wrapper {
    width: 100%;
  }
  ::v-deep .van-popup {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .wrapper {
    width: 276px * $zoom;
  }
  ::v-deep .van-popup {
    width: 276px * $zoom;
  }
}
.wrapper {
  height: 100vh;
  #mapContainer {
    // width: 680px;
    font-size: 16px * $zoom;
    padding: 0px;
    margin: 0px;
    height: 100%;
    .search {
      margin-left: 5%;
      .markerTitle {
        position: relative;
        z-index: 9999;
        display: flex;
        margin-top: 20px;
        margin-bottom: 55px;
        .img {
          width: 29px;
          height: 35px;
          margin-right: 10px;
        }
        .title {
          font-size: 27px;
          font-weight: 600;
        }
      }
      ::v-deep .van-field {
        width: 607px;
        height: 70px;
        border-radius: 20px;
        z-index: 9999;
      }
    }
  }
  .location {
    .container {
      height: 400px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .locationContainer {
        .locationInfo {
          margin-top: 60px;
          padding: 0 20px;
          &::-webkit-scrollbar {
            display: none;
          }
          .shop {
            display: flex;
            font-size: 27px;
            line-height: 53px;
            align-items: flex-end;
            justify-content: space-between;
            .shopTitle {
              // width: 500px;
              width: 78%;
              white-space: normal;
              word-break: break-all;
            }
            .meter {
              min-width: 130px;
            }
          }
          .info {
            display: flex;
            font-size: 24px;
            justify-content: space-between;
            .content {
              display: flex;
              align-items: center;
              .mark {
                width: 22px;
                height: 26px;
                margin-right: 10px;
              }
              .infoContent {
                // width: 470px;
                width: 86%;
                white-space: normal;
                word-break: break-all;
                color: #ababab;
              }
            }
            .linkNavigation {
              display: flex;
              align-items: center;
              min-width: 130px;
              .img {
                width: 33px;
                height: 33px;
                margin-right: 10px;
              }
              .title {
                flex-shrink: 0;
                font-size: 27px;
              }
            }
          }
        }
      }
    }

    ::v-deep .van-popup__close-icon {
      margin-left: 47%;
      height: 50px;
      width: 50px;
      bottom: 0;
    }
    ::v-deep .van-popup__close-icon--top-right {
      position: fixed;
      top: 93%;
      right: 48%;
    }
    ::v-deep .van-icon-cross:before {
      content: "";
      background-image: url("~@/assets/gzh/bottomArrows2.png");
      background-size: cover;
      width: 50px;
      height: 15px;
    }
  }
  ::v-deep .van-popup--bottom {
    left: initial;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
